import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const NotebookCheck = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7.91h1.619M3 12h1.619M3 16.09h1.619m4.857-4.265 2.061 2.343 3.606-4.295M6.393 3h11.832C19.205 3 20 3.806 20 4.8v14.4c0 .994-.795 1.8-1.775 1.8H6.394c-.98 0-1.775-.806-1.775-1.8V4.8c0-.994.795-1.8 1.775-1.8"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(NotebookCheck) as SvgIcon;
export { ForwardRef as ReactComponent };
